export const MODEL_POSITION_STEP = 0.01;
export const MATERIAL_PROPERTIES_STEP = 0.01;
export const CAMERA_PROPERTIES_STEP = 0.1;
export const MEASURETOOL_PROPERTIES_STEP = 0.01;
export const MIN_PROPERTIES_VALUE = 0;
export const MAX_PROPERTIES_VALUE = 1;
export const MATERIAL_PROPERTIES_ROTATION_STEP = 1;

export const WINDOWS = 'WINDOWS'
export const ANDROID = 'ANDROID'
export const IOS = 'IOS'
